/// <amd-module name="SuiteCommerce.GiftCertificate.PDP"/>
define("SuiteCommerce.GiftCertificate.PDP", ["require", "exports", "SuiteCommerce.GiftCertificate.OptionTiles.Configuration", "SuiteCommerce.GiftCertificate.OptionTiles", "SuiteCommerce.GiftCertificate.OptionTiles.Tile.Collection", "SuiteCommerce.GiftCertificate.OptionTiles.Tile.Model", "SuiteCommerce.GiftCertificate.OptionTiles.TilesContainer.View"], function (require, exports, OptionTiles_Configuration_1, OptionTiles_1, OptionTiles_Tile_Collection_1, OptionTiles_Tile_Model_1, OptionTiles_TilesContainer_View_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            if (this.isEnabledGroupCertificatesAsItemOptions()) {
                OptionTiles_1.OptionTiles.excludeGiftCertificatesFromSearch();
                this.mountOptionTilesComponent(container.getComponent('PDP'), container.getComponent('Environment'));
            }
        },
        isEnabledGroupCertificatesAsItemOptions: function () {
            return OptionTiles_Configuration_1.OptionTilesConfiguration.groupCertificatesAsItemOptions;
        },
        mountOptionTilesComponent: function (pdp, environment) {
            var childViewConstructor = {
                'Product.Options': {
                    'GiftCertificate.Tiles': {
                        childViewIndex: 1,
                        childViewConstructor: function () {
                            var tileModel = new OptionTiles_Tile_Model_1.TileModel(pdp.getItemInfo().item);
                            if (tileModel.isGiftCertificateItem()) {
                                return new OptionTiles_TilesContainer_View_1.TilesContainerView({
                                    model: tileModel,
                                    collection: new OptionTiles_Tile_Collection_1.TileCollection({
                                        environment: environment,
                                        filters: {
                                            itemtype: 'GiftCert',
                                            custitem_ns_sc_ext_gift_cert_group_id: tileModel.giftCertificateGroupId,
                                        },
                                    }),
                                });
                            }
                        },
                    },
                },
            };
            var viewsToInject = [pdp.PDP_FULL_VIEW];
            OptionTiles_1.OptionTiles.injectInVisualComponent(pdp, {
                childViewConstructor: childViewConstructor,
                viewsToInject: viewsToInject,
            });
        },
    };
});
